// Copyright (c) Meta Platforms, Inc. and affiliates.
// All rights reserved.

// This source code is licensed under the license found in the
// LICENSE file in the root directory of this source tree.

import * as React from "react";
import ReactDOM from 'react-dom/client';
import './App.css';
import AppContextProvider from "./components/hooks/context";
import App from "./App";
import Main from "./Main";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { Indexpagedata } from "./contextapi/Indexpagedata";
import { SettingsProvider } from "./contextapi/SettingsContext";
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { initializeAnalytics } from "./analytics";

initializeAnalytics();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store} >
  <AppContextProvider>
  <Indexpagedata>
  <SettingsProvider>

  
     <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

<PrimeReactProvider>
    <Main/>
    </PrimeReactProvider>
    </SettingsProvider>
    </Indexpagedata>
  </AppContextProvider>
  </Provider>
);
